import { useGetVehiclesQuery } from '@/pages/Fleet/Vehicles/services/vehicles.service.ts';

import { VehicleFilter } from '@/pages/Fleet/Vehicles/services/vehicles.service';

type UseVehiclesProps = {
  filters?: VehicleFilter;
  page: number;
  pageSize: number;
  skip?: boolean;
};

const useVehicles = ({ filters, page, pageSize, skip }: UseVehiclesProps) => {

  const { data, isLoading, error } = useGetVehiclesQuery( { filters, paginated: { page, pageSize } }, { skip } );

  return {
    isLoading, error,
    vehicles: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
  };

};

export default useVehicles;
